import sys_manage_config_list from './config-list';
import sys_manage_config_edit from './config-edit';

export default {
    sys_manage_config_list,
    sys_manage_config_edit,
};
